import Links from '@/shared/constants/navegacao';
import MyContext from '@/shared/contexts/AppContext';
import { Button } from 'react-bootstrap';
import { CarregarPermissoes, ValidarPermissao, getLoginTokenFromStorage, } from '@/modules/system/auth/application/auth.service';
import { Fragment, useContext, useEffect, useMemo, useState } from 'react';
import { ModuloSistema } from '@/shared/constants/modulos-sistema.enum';
import { RoleEnum } from '@/modules/system/papeis/enum/role.enum';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { PermissionEnum } from '@/modules/system/papeis/enum/permission.enum';

export default function EscolhaModulo() {
  const navigate = useNavigate();
  const context = useContext(MyContext);
  const TOKEN = getLoginTokenFromStorage();
  const [isNotLoggedIn] = useState(TOKEN === null || TOKEN === undefined);

  const permissoes = useMemo(() => CarregarPermissoes(), []);

  const permissaoFerias = ValidarPermissao(permissoes, [{ role: RoleEnum.LOTACAO, level: PermissionEnum.READ }]);
  const permissaoMovimentacoes = ValidarPermissao(permissoes, [{ role: RoleEnum.MOVIMENTACAO, level: PermissionEnum.READ }]);
  const permissaoFolhas = ValidarPermissao(permissoes, [{ role: RoleEnum.FOLHA, level: PermissionEnum.READ }]);

  if (!context)
    throw new Error('DisplayComponent deve ser usado dentro de um MyProvider');
  const { state, setState } = context;

  const handleChageModulo = (novoModulo: ModuloSistema) => {
    setState({ ...state, modulo: novoModulo });
    navigate(`${Links.Index}`);
  };

  useEffect(() => {
    if (isNotLoggedIn) navigate(`${Links.Auth_Login}`);
  }, []);

  return (
    <Fragment>
      <ToastContainer position="top-center" />
      <section className="ftco-section">
        <div className="loginrow w-100 justify-content-center">
          <div
            className=""
            style={{ width: '75%', minWidth: '25%', maxWidth: '75%' }}
          >
            <div className="d-flex mb-5">
              <div className="w-100">
                <h4>Módulo</h4>
                <span id="escolha-modulo">
                  Escolha o módulo que deseja acessar.
                </span>
              </div>
            </div>

            <div className="row">
              {permissaoFerias && (
                <div
                  className="col-md-4"
                  title="Registra onde estão lotados os defensores, colaboradores e estagiários."
                >
                  <Button id="btn-modulo-ferias"
                    type="submit"
                    className="form-control loginbtn loginbtn-primary"
                    onClick={() => {
                      handleChageModulo(ModuloSistema.Ferias);
                    }}
                  >
                    Lotações
                  </Button>
                </div>
              )}
              {permissaoMovimentacoes && (
                <div
                  className="col-md-4"
                  title="Registra os relatórios de atividades dos defensores."
                >
                  <Button
                    type="submit"
                    className="form-control loginbtn loginbtn-primary loginbtn-movimentos"
                    onClick={() => {
                      handleChageModulo(ModuloSistema.Movimentacoes);
                    }}
                  >
                    Movimentações
                  </Button>
                </div>
              )}
              {permissaoFolhas && (
                <div
                  className="col-md-4"
                  title="Gerencia as folhas de frequências dos estagiários"
                >
                  <Button
                    type="submit"
                    className="form-control loginbtn loginbtn-primary loginbtn-blue"
                    onClick={() => {
                      handleChageModulo(ModuloSistema.FolhaFrequencia);
                    }}
                  >
                    Folhas de Frequências
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
}
